import { auth } from "api/config";

export const getCurrentUserId = (): string => {
  const { currentUser } = auth;
  if (currentUser) {
    return currentUser.uid;
  }
  return '';
};